import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTickCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 24 24",
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M12,0L12,0c6.6,0,12,5.4,12,12l0,0c0,6.6-5.4,12-12,12l0,0C5.4,24,0,18.6,0,12l0,0C0,5.4,5.4,0,12,0z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12,0.8L12,0.8c6.2,0,11.2,5,11.2,11.2l0,0c0,6.2-5,11.2-11.2,11.2l0,0c-6.2,0-11.2-5-11.2-11.2l0,0 C0.8,5.8,5.8,0.8,12,0.8z",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(-2.917 -2.458)",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
				d: "M9,14.6l4.1,4.1l7.9-8.6",
				fill: "none",
				stroke: "currentColor",
				strokeWidth: 1.5
			}) })
		})
	]
});
export { SvgTickCircle as ReactComponent };
